export const CONNECTION_ERROR = "Erreur de connexion";
export const CONNECTION_IMPOSSIBLE = "Connexion impossible";
export const BAD_CODE = "Code incorrect ou expiré. Veuillez réessayer.";
export const LOCKEDOUT_MESSAGE = "Le nombre de tentatives autorisé est dépassé";

export const ERROR_HTTP_401 = "Vous n'êtes pas autorisé à accéder à cette page.";
